<button
  [disabled]="filterValues?.length === 1"
  atxDropdown
  atxPlacement="bottomRight"
  class="btn btn-light d-flex align-items-center"
  [atxDropdownMenu]="userMenu"
  [atxClickHide]="false"
>
  @if (selectedValues?.length > 0) {
  <span class="mr-1 text-truncate font-size-sm" data-e2e="filter-label">
    {{ selectedValuesText() }}
  </span>
  } @else { @if (selectedValues?.length === 1) {
  {{ filterValues[0]?.value }}
  } @else {
  <fa-icon class="font-size-sm mr-2" [icon]="['fas', 'flag']"></fa-icon>
  <span class="font-size-sm">{{ defaultText }}</span>
  } }

  <fa-icon
    class="font-size-sm ml-auto"
    [icon]="['fas', 'angle-down']"
  ></fa-icon>
</button>

<atx-dropdown-menu
  #userMenu="atxDropdownMenu"
  [extraClasses]="['dashboard-dropdown']"
>
  <atx-dropdown-item
    (click)="filterSelected(null)"
    [active]="selectedValues?.length === 0"
  >
    <span class="font-size-base text-muted">{{ showAllText }}</span>
  </atx-dropdown-item>
  @for (option of filterValues; track trackByValue($index, option); let isEven =
  $even) {
  <atx-dropdown-item
    [active]="isSelected(option.key)"
    [class.my-2]="isEven"
    (click)="filterSelected(option.key)"
  >
    <span class="font-size-base text-muted">{{ option.value }}</span>
  </atx-dropdown-item>
  }
</atx-dropdown-menu>
